var map = {
	"./android.png": 6545,
	"./angular.png": 738,
	"./aws.png": 1455,
	"./ionic.png": 3838,
	"./ios.png": 5807,
	"./microsoft-azure.png": 1086,
	"./mongo-db.png": 1301,
	"./mysql.png": 486,
	"./net-core.png": 5025,
	"./node-js.png": 8100,
	"./openshift.png": 7968,
	"./react-native.png": 5669,
	"./reactjs.png": 6779,
	"./salesforce.png": 8095,
	"./spring-boot.png": 8992,
	"./sql-server.png": 2014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9905;